import { FormattedMessage } from "react-intl"
import { Heading, P } from "shared/styles/textStyles"
import styled from "styled-components"

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  max-width: 100%;
  width: 350px;
`

const Title = styled(Heading)`
  font-weight: 600;
  font-size: 1.43rem;
  margin: 40px 0 10px;
`

const Message = styled(P)`
  font-weight: 400;
  font-size: 1.25rem;
  margin-bottom: 308px; // To make the modal approximately equal to the previous page
`

const ReportSuccess = () => (
  <Wrapper>
    <Title>
      <FormattedMessage
        id="report.successTitle"
        defaultMessage="Thank you!"
      />
    </Title>
    <Message>
      <FormattedMessage
        id="report.successMessage"
        defaultMessage="Stage TEN will review this channel shortly."
      />
    </Message>
  </Wrapper>
)

export default ReportSuccess
